import { defineStore } from 'pinia';

export const useRedirectPathStore = defineStore('redirectPath', {
  state: () => ({
    redirectPath: '/',
  }),
  getters: {
    path: (state) => state.redirectPath,
  },
  actions: {
    setPath(path: string) {
      this.redirectPath = path;
    },
    initPath() {
      this.redirectPath = '/';
    },
  },
});
